module.exports = __webpack_public_path__ + "img/mainHome.d3e907c9.png";